import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { environment } from "@environments/environment";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

if (environment.production) {
  console.log("production");
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);

registerLocaleData(localeEs);

